import { Box, Container } from '@mui/material'
import type { FC, ReactNode } from 'react'

type PageShellProps = {
  readonly children: ReactNode
  readonly maxWidth?: 'sm' | 'md' | 'lg'
  readonly className?: string
}

const PageShell: FC<PageShellProps> = ({
  children,
  maxWidth = 'lg',
  className = 'page'
}) => {
  return (
    <Box component='main' className={className}>
      <Container maxWidth={maxWidth} sx={{ py: { xs: 4, md: 6 }, px: { xs: 2, sm: 3 } }}>
        {children}
      </Container>
    </Box>
  )
}

export default PageShell
